import { default as WJElement } from '../wje-element/element.js';
import CarouselItem from './carousel-item.element.js';

// export * from "./carousel-item.element.js";
export default CarouselItem;

WJElement.define('wje-carousel-item', CarouselItem);
